import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { ParsedPlatformSettings } from '@/core/services/platformSettingsService';

interface PlatformSettingsState {
  settings: ParsedPlatformSettings;
  isLoaded: boolean;
  setSettings: (settings: ParsedPlatformSettings) => void;
  setLoaded: (loaded: boolean) => void;
}

const defaultSettings: ParsedPlatformSettings = {
  themes: { dark: {}, light: {} },
  staticColors: {},
  branding: {},
  typography: {},
  dimensions: {},
  features: {},
  maintenance: {},
};

export const usePlatformSettingsStore = create<PlatformSettingsState>()(
  persist(
    (set) => ({
      settings: defaultSettings,
      isLoaded: false,
      setSettings: (settings) => set({ settings }),
      setLoaded: (loaded) => set({ isLoaded: loaded }),
    }),
    {
      name: 'platform-settings-storage',
    }
  )
);

// Helper selectors
export const selectBranding = (state: PlatformSettingsState) => state.settings.branding;
export const selectFeatures = (state: PlatformSettingsState) => state.settings.features;
export const selectTypography = (state: PlatformSettingsState) => state.settings.typography;
export const selectDimensions = (state: PlatformSettingsState) => state.settings.dimensions;
export const selectThemes = (state: PlatformSettingsState) => state.settings.themes;
export const selectStaticColors = (state: PlatformSettingsState) => state.settings.staticColors;
export const selectMaintenance = (state: PlatformSettingsState) => state.settings.maintenance;
